import { css } from "styled-components";
import { asset } from "../tokens/ts/assets";
export const fontFaces = css `
  @font-face {
    font-family: "MW-Flow-Regular";
    src: url(data:font/ttf;base64,${asset.font.brand.Inter.woff.regular});
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "MW-Flow-Regular";
    src: url(data:font/ttf;base64,${asset.font.brand.Inter.woff.bold});
    font-weight: bold;
  }

  @font-face {
    font-family: "MW-Flow-PageTitle";
    src: url(data:font/ttf;base64,${asset.font.brand.ProximaNova.woff});
    font-weight: bold;
  }

  @font-face {
    font-family: "MW-Flow-Mono";
    src: url(data:font/ttf;base64,${asset.font.base.RobotoMono.ttf});
  }
`;
export default fontFaces;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZm9udEZhY2VzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL21peGlucy9mb250RmFjZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEdBQUcsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3hDLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSxxQkFBcUIsQ0FBQztBQUU1QyxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsR0FBRyxDQUFBOzs7b0NBR1EsS0FBSyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxPQUFPOzs7Ozs7O29DQU9uQyxLQUFLLENBQUMsSUFBSSxDQUFDLEtBQUssQ0FBQyxLQUFLLENBQUMsSUFBSSxDQUFDLElBQUk7Ozs7OztvQ0FNaEMsS0FBSyxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsV0FBVyxDQUFDLElBQUk7Ozs7OztvQ0FNakMsS0FBSyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsVUFBVSxDQUFDLEdBQUc7O0NBRWpFLENBQUM7QUFFRixlQUFlLFNBQVMsQ0FBQyJ9